import { useMutation } from '@tanstack/react-query'

import { visitorParkingAPI } from '@/api/new-api'

interface RetryVisitorParkingPaymentRequest {
  sessionId: number
  duration: number
  visitorId: number
}

interface RetryVisitorParkingPaymentResponse {
  ticketNumber: string
  amount: number
  clientSecret: string
  sessionId: number
  visitorId: number
}

export const retryVisitorParkingPayment = async (data: RetryVisitorParkingPaymentRequest) => {
  const response = await visitorParkingAPI.post<RetryVisitorParkingPaymentResponse>(
    `/visitor-parking/retry-payment`,
    data,
  )
  return response.data
}

export const useRetryVisitorParkingPayment = () => {
  return useMutation({
    mutationFn: retryVisitorParkingPayment,
  })
}
